import { Grid } from "@mui/material";
import useLocales from "src/hooks/useLocales";

import InfoItem from "./components/InfoItem";

// ----------------------------------------------------------------------

type Props = {
	aboutData: string;
};

export const InfoItems = ({ aboutData }: Props) => {
	const { translate } = useLocales();

	return (
		<Grid container item xs={12} sm={6} rowSpacing={{ sm: 3, xs: 2 }}>
			<Grid item xs={12}>
				<InfoItem
					title={translate("info_panel.about_data")}
					description={aboutData}
					icon='mage:user-check'
				/>
			</Grid>
			<Grid item xs={12}>
				<InfoItem
					title={translate("info_panel.security")}
					description={translate("info_panel.security_des")}
					icon='material-symbols:security'
					seeMore='https://www.vumi.io/seguridad'
				/>
			</Grid>
			<Grid item xs={12}>
				<InfoItem
					title={translate("info_panel.only_read")}
					description={translate("info_panel.only_read_des")}
					icon='iconoir:page-search'
				/>
			</Grid>
		</Grid>
	);
};

export default InfoItems;
